// extracted by mini-css-extract-plugin
module.exports = {"container":"RegisterPage_container__2TrP1","has-sidebar":"RegisterPage_has-sidebar__k1xFY","icon":"RegisterPage_icon__3ncip","aside":"RegisterPage_aside__2xNQH"};